import { render, staticRenderFns } from "./MobDetail.vue?vue&type=template&id=9f499ed2&scoped=true"
import script from "./MobDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MobDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobDetail.vue?vue&type=style&index=0&id=9f499ed2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f499ed2",
  null
  
)

export default component.exports